// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getBeginWeeks, getConstraintKey, getConstraintTypeForOrderBundle, getEndWeeks
} from '../../common/repositories';
import { getOrderUsingOptionDropDown, getOrderUsingOptions } from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import OptionsDropDown from '../../shared/components/options-drop-down';
import OrdersUsingOptionsTable from './components/orders-using-options-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class OrdersUsingOptions extends Component {

    state = {
        types: [],
        keys: [],
        selectedKey: '',
        selectedType: '',
        results: null,
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: '',
        options: [],
        selectedOptionOne: '',
        selectedOptionTwo: '',
        selectedOptionThree: '',
        selectedOptionOneObj: null,
        selectedOptionTwoObj: null,
        selectedOptionThreeObj: null,
        selectedKeyObj: null

    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getConstraintTypeForOrderBundle( ).then( response => {

            this.setState( {
                types: response
            } );
            this.props.decreaseCounter();

        } );

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedType: val,
            selectedKey: '',
            selectedKeyObj: null,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''

        }, () => {

            if ( this.state.selectedType !== '-1' ) {

                this.props.increaseCounter();
                getConstraintKey( val ).then( response => {

                    const keys = response.map( item => ( {
                        label: item.id.trim(),
                        value: item.value.trim()
                    } ) );
                    this.setState( {
                        keys,
                        selectedKey: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleKeyChange ( val ) {

        this.setState( {
            selectedKey: val.label,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: '',
            selectedKeyObj: val
        }, () => {

            if ( this.state.selectedKey !== '-1' ) {

                this.props.increaseCounter();
                getBeginWeeks( ).then( response => {

                    const bWeeks = response.map( i => {

                        const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        beginWeeks: bWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: '',
            results: null
        }, () => {

            if ( this.state.selectedBeginWeek !== '-1' ) {

                this.props.increaseCounter();
                getEndWeeks( val ).then( response => {

                    const eWeeks = response.map( i => {

                        const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        endWeeks: eWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            if ( this.state.selectedEndWeek !== '-1' ) {

                this.props.increaseCounter();
                getOrderUsingOptionDropDown( ).then( response => {

                    const optionResp = response.map( item => ( {
                        label: item.id.trim(),
                        value: item.value.trim()
                    } ) );
                    this.setState( {
                        options: optionResp,
                        selectedOptionOne: '',
                        selectedOptionTwo: '',
                        selectedOptionThree: '',
                        selectedOptionOneObj: null,
                        selectedOptionTwoObj: null,
                        selectedOptionThreeObj: null,
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleOptionOne ( val ) {

        this.setState( {
            selectedOptionOne: val.label === '-1' ? '' : val.label,
            selectedOptionOneObj: val
        } );

    }

    handleOptionTwo ( val ) {

        this.setState( {
            selectedOptionTwo: val.label === '-1' ? '' : val.label,
            selectedOptionTwoObj: val
        } );

    }

    handleOptionThree ( val ) {

        this.setState( {
            selectedOptionThree: val.label === '-1' ? '' : val.label,
            selectedOptionThreeObj: val
        } );

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value === null ? this.state[`${name}`] : val.target.value
        }, () => {

            this.setDropDownValue( this.state[`${name}`], name );

        } );

    }

    handleOrderUsingOptions ( constraintType, constraintKey, beginWeek,
        endWeek, option1, option2, option3 ) {

        this.props.increaseCounter();
        const payload = {
            constraintType,
            constraintKey,
            beginWeek,
            endWeek,
            option1,
            option2,
            option3
        };
        getOrderUsingOptions( payload )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    setDropDownValue ( val, name ) {

        const optionArray = this.state.options;
        const resp = optionArray.map( value => {

            if ( value.label === val ) {

                return value;

            }
            return '';

        } );

        this.setState( {
            [`${name}Obj`]: resp
        } );

    }

    refresh = () => {

        if ( this.state.selectedType !== '-1' && this.state.selectedKey !== '-1'
            && this.state.selectedBeginWeek !== '-1' && this.state.selectedEndWeek !== '-1'
            && ( this.state.selectedOptionOne !== '-1' || this.state.selectedOptionTwo !== '-1'
            || this.state.selectedOptionThree !== '-1' ) ) {

            this.handleOrderUsingOptions( this.state.selectedType, this.state.selectedKey,
                this.state.selectedBeginWeek, this.state.selectedEndWeek,
                this.state.selectedOptionOne, this.state.selectedOptionTwo,
                this.state.selectedOptionThree );

        }

    }

    render () {

        const {
            selectedKey, selectedType, types, keys, selectedBeginWeek,
            selectedEndWeek, beginWeeks, endWeeks, results, options,
            selectedOptionOne, selectedOptionTwo, selectedOptionThree,
            selectedOptionOneObj, selectedOptionTwoObj, selectedOptionThreeObj,
            selectedKeyObj
        } = this.state;

        const mapResults = [];
        let k = 1;
        let orders = 0;
        if ( results !== null && results !== undefined ) {

            for ( let i = 0; i < results.length; i += 1 ) {

                const resultWithUnitName = results[i].orderUsingOptionDtails.map( order => (
                    { ...order, ...{ unitName: this.props.unit.name } } ) );
                orders += resultWithUnitName.length;
                const totalOrderForGrid = resultWithUnitName.length;
                resultWithUnitName[totalOrderForGrid] = { model: '0', message: `Total Orders: ${totalOrderForGrid}` };
                mapResults[k] = resultWithUnitName;
                mapResults[k].buildWeek = results[i].weekEnding;
                k += 1;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Orders Using Options</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-using-options-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-order-using-options-select"
                                    label="Type"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={types}
                                    placeholder="Select Type"
                                    selectedValue={selectedType}
                                />
                                {selectedType && selectedType !== '-1' && (
                                    <LabeledReactSelect
                                        className="atp-order-using-options-select"
                                        label="Key"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleKeyChange.bind( this )}
                                        options={keys}
                                        placeholder="Select Key"
                                        selectedValue={selectedKeyObj}
                                    />
                                )}
                                {selectedType && selectedKey && selectedKey !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-order-using-options-select"
                                        label="Begin Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={beginWeeks}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                    />
                                )}
                                {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-order-using-options-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="atp-order-using-options-label-top-options">
                            {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-options-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-options-select-values"
                                            label="Option 1"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleOptionOne.bind( this )}
                                            options={options}
                                            placeholder="Option 1"
                                            selectedValue={selectedOptionOneObj}
                                        />
                                        <LabeledInput
                                            className="atp-order-using-options-label-input"
                                            name="selectedOptionOne"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedOptionOne' )}
                                            value={selectedOptionOne}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}
                            {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-options-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-options-select-values"
                                            label="Option 2"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleOptionTwo.bind( this )}
                                            options={options}
                                            placeholder="Option 2"
                                            selectedValue={selectedOptionTwoObj}
                                        />
                                        <LabeledInput
                                            className="atp-order-using-options-label-input"
                                            name="selectedOptionTwo"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedOptionTwo' )}
                                            value={selectedOptionTwo}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}
                            {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-options-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-options-select-values"
                                            label="Option 3"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleOptionThree.bind( this )}
                                            options={options}
                                            placeholder="Option 3"
                                            selectedValue={selectedOptionThreeObj}
                                        />

                                        <LabeledInput
                                            className="atp-order-using-options-label-input"
                                            name="selectedOptionThree"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedOptionThree' )}
                                            value={selectedOptionThree}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="export-report-button">
                            {selectedType && selectedKey && selectedBeginWeek
                                && selectedEndWeek && (
                                <button className="primary-button" type="button" onClick={this.refresh.bind( this )}>
                                    <span> Create Report </span>
                                </button>
                            )}
                        </div>
                        <section className="messagecontainer">
                            {results !== null && selectedType && selectedKey && selectedBeginWeek
                                && selectedEndWeek &&
                                ( selectedOptionOne || selectedOptionTwo
                                || selectedOptionThree ) && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && selectedType && selectedKey && selectedBeginWeek
                                && selectedEndWeek &&
                                ( selectedOptionOne || selectedOptionTwo
                                || selectedOptionThree ) && (
                                <div className="displayErrorMessage">Total Orders for Time Period: {orders}</div>
                            ) }
                        </section>
                        {results !== null && selectedType && selectedKey && selectedBeginWeek
                        && selectedEndWeek &&
                        ( selectedOptionOne || selectedOptionTwo || selectedOptionThree ) &&
                        mapResults !== undefined && mapResults.map( ( item, index ) => (
                            <OrdersUsingOptionsTable
                                key={`options-table-${item.buildWeek}-${index}`}
                                results={item}
                                buildWeek={item.buildWeek}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OrdersUsingOptions.displayName = 'OrdersUsingOptions';
OrdersUsingOptions.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OrdersUsingOptions ) );
